type Props = {
  title: string;
  description: string;
  url: string;
  imageUrl: string;
  type?: 'website' | 'article';
};

const FacebookMetaTags = ({ title, description, url, imageUrl, type = 'website' }: Props) => {
  return (
    <>
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
    </>
  );
};

export default FacebookMetaTags;
